import * as t from 'io-ts';

/**
 * Basic shared schemas for usage as values in other schemas.
 */

export const genericStatusMessage = t.type({ success: t.boolean });

export const primitiveValue = t.union([t.boolean, t.number, t.string, t.null]);
